module.exports = __webpack_public_path__ + "static/media/mbpreview.6e37aff1.png";